import styled from 'styled-components';
import IndexContentContainer from "../../../index/IndexContentContainer";
import useBookDetailStore from "../useBookDetailStore";
import EmptyResult from "../../../../common/EmptyResult";
import {useState} from "react";
import BookDetailReviewModal from "./BookDetailReviewModal";
import parse from "html-react-parser";

const BookDetailReviewCard = () => {
    const {book} = useBookDetailStore()
    const [isOpen, setIsOpen] = useState<boolean>(false)

    return (
        <IndexContentContainer isNotHover={true}>
            <BookDetailReviewModal isOpen={isOpen} close={() => setIsOpen(false)}/>

            <Container onClick={() => setIsOpen(true)}>
                {
                    (book?.review == null || book.review === '') ?
                        <NoContent/>
                        :
                        <TextContainer>
                            {parse(book?.review)}
                        </TextContainer>
                }
            </Container>
        </IndexContentContainer>
    )
}

const NoContent = () => {
    return <EmptyResult icon="✍️" title="추가한 감상이 없어요" description="여기를 클릭해서 감상을 추가할 수 있어요" />
}

const Container = styled.div`
    width: 100%;
    min-height: 200px;
    
    &:hover {
        color: black;
    }
`

const TextContainer = styled.p`
    margin: 0;
    padding: 0 10px;

    font-size: 15px;
    line-height: 1.6;

    color: var(--text-color);
    white-space: pre-wrap;

    letter-spacing: 0.01em; 
`

export default BookDetailReviewCard
